import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://akarma.com.tr/upload/akarma/slide1.jpg',
      title: 'Kurumsal Eğitimler',
      subtitle: 'Stratejik Liderlik Eğitimi',
      points: [
        'Kurumun temel değerlerini kavrayarak hareket etmesini',
        'Kurumun stratejik planını analiz etmesi ve ona göre liderlik stillerini ortaya koymasını',
        'Kurum kültürünün stratejisi ile ilişkisini yönetmesini',
        'Etkin liderlik yaklaşımın yukarıdan aşağıya indirgenmesini',
        'Kurumun vizyon ve misyonu ile ilgili ilham vermesini'
      ]
    },
    {
      image: 'https://akarma.com.tr/upload/akarma/slide3.jpg',
      title: 'Çankaya Köşkünde',
      subtitle: 'toplu meditasyon yaptık',
      description: 'Keskin Zeka, Sağlam Beden, Özgür Ruh temalı sunumumuz.'
    },
    {
      image: 'https://akarma.com.tr/upload/akarma/slide2.jpg',
      title: 'Kurumsal Eğitimler',
      subtitle: 'Yönetici Koçluğu',
      description: 'Bu seminerde, katılımcıların farklı davranış ve iletişim kalıplarını öğrenerek yepyeni bir farkındalık kazanmaları hedeflenir. Kişiler böylelikle, profesyonel ve özel hayat içinde karşılaştıkları tüm bireyleri daha iyi anlama ve tanıma şansına sahip olacakları için daha uyumlu, verimli ve mutlu ilişkiler geliştirebilirler.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative h-screen overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-akarma-blue/95 via-akarma-blue/85 to-akarma-blue/75"></div>
          </div>

          {/* Content */}
          <div className="relative h-full flex items-center">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl">
                <h2 className="text-white text-2xl md:text-3xl font-semibold mb-4 animate-fadeIn">
                  {slide.title}
                </h2>
                <h1 className="text-white text-4xl md:text-6xl font-bold mb-8 animate-fadeIn">
                  {slide.subtitle}
                </h1>
                
                {slide.points && (
                  <ul className="space-y-3 text-white text-lg md:text-xl">
                    {slide.points.map((point, idx) => (
                      <li key={idx} className="flex items-start animate-slideIn" style={{ animationDelay: `${idx * 0.1}s` }}>
                        <span className="mr-3 mt-1">•</span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
                
                {slide.description && (
                  <p className="text-white text-xl md:text-2xl leading-relaxed max-w-3xl animate-fadeIn">
                    {slide.description}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm p-3 rounded-full transition-all duration-300 group z-10"
        aria-label="Previous slide"
      >
        <ChevronLeft size={28} className="text-white group-hover:scale-110 transition-transform" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm p-3 rounded-full transition-all duration-300 group z-10"
        aria-label="Next slide"
      >
        <ChevronRight size={28} className="text-white group-hover:scale-110 transition-transform" />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Add animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }

        .animate-slideIn {
          animation: slideIn 0.6s ease-out;
        }
      `}</style>
    </div>
  );
};

export default HeroSlider;
